/*
 * Authors: koenweyn, mariushirjanu
 * Created: 07/10/2015
 */

import { Injectable } from '@angular/core';
import { FormattingService } from '../../shared/services/formatting.service';
import { PAYMENT_STATUS_OPEN, PAYMENT_STATUS_REFUSED } from './payment-data.service';
import { TranslationService } from '../../shared/translation/translation.service';

const successIcon:string = ' <i class="fa fa-check-circle text-success"></i>';
const failedIcon:string = ' <i class="fa fa-exclamation-circle text-danger"></i>';

@Injectable()
export class PaymentFormattingService {
  constructor(
    private formattingService:FormattingService,
    private translationService:TranslationService
  ) {
  }

  public formatPaymentStatus = (paymentStatus:string, paymentType:string, paymentTotal:number | string, paymentCurrency:string, paymentDate:number | Date):string => {
    switch (paymentStatus) {
      case PAYMENT_STATUS_OPEN:
        return 'Open';
      case 'PAID_CLEARING':
      case 'PAID_WAITING':
      case 'PAID_RECEIVED':
        return this.translationService.instant('ORDERENTRY.PAYMENT.PAID_MESSAGE', {
          amount: this.formattingService.formatAmount(paymentTotal, paymentCurrency),
          date: this.formattingService.formatDate(paymentDate)
        }) + successIcon;
      case 'WAITING':
        return this.translationService.instant((!paymentType || paymentType === 'PO')? 'ORDERENTRY.PAYMENT.WAITING_PO_MESSAGE' : 'ORDERENTRY.PAYMENT.WAITING_CC_MESSAGE') + successIcon;
      case PAYMENT_STATUS_REFUSED:
        return this.translationService.instant('ORDERENTRY.PAYMENT.REFUSED_MESSAGE') + failedIcon;
      case 'CLOSED':
        return 'Closed/Bad debt';
      case 'TO_BE_CANCELLED':
        return 'Payment to be cancelled';
      default:
        return paymentStatus;
    }
  };
}